import { render, staticRenderFns } from "./CreateMachineScroll.vue?vue&type=template&id=6be0b7bb"
import script from "./CreateMachineScroll.vue?vue&type=script&lang=js"
export * from "./CreateMachineScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports